import { Link } from "react-router-dom";
import BRAND from "../../config/brand";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Brand Section */}
        <div className="footer-brand">
          <h3>{BRAND.name}</h3>
          <p>{BRAND.tagline}</p>

          {/* 💬 Feedback Card */}
          <div className="footer-feedback-card">
            <h4>💡 Share Your Idea</h4>
            <p>
              What feature should we build next?
              Tell us what you need inside Learnlia.
            </p>

            {/* 🔗 Replace with your Google Form link */}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfDfE5Pq1AUmi5XAJF9gRxGkDZ4tRVnVIRRZXVgonSK1_0zaA/viewform?usp=publish-editor"
              target="_blank"
              rel="noopener noreferrer"
              className="feedback-btn"
            >
              Share Feedback →
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="footer-links">

          <div className="footer-column">
            <h4>Product</h4>
            <Link to="/dashboard">Dashboard</Link>
            <Link to="/add-course">Add Course</Link>
            <Link to="/roadmap">Roadmap</Link>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeeAAnHKwPG-5rUV9k4sq28vbv7up-lsmRCgB2q-2WhSYUMCA/viewform?usp=publish-editor"
              id="report"
              target="_blank"
              rel="noopener noreferrer"
            >
              Report a Bug
            </a>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/guide">Guide</Link>
          </div>

          <div className="footer-column">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cancellation-refund-policy">Cancellation & Refund Policy</Link>
            <Link to="/shipping-delivery-policy">Shipping & Delivery Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/cookies">Cookie Policy</Link>
            <Link to="/certificate-policy">Certificate Policy</Link>
          </div>

          {/* <div className="footer-column">
            <h4>Resources</h4>
            <Link to="/help">Help Center</Link>
            <Link to="/guide">YouTube Guide</Link>
            <Link to="/status">System Status</Link>
          </div> */}

        </div>
      </div>

      {/* Bottom Strip */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;